module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getOwners
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.owners,
      "highlight-current-row": "",
      "border": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "DataID",
      "width": "100",
      "label": "编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Code",
      "label": "自定义编码",
      "width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "width": "180",
      "sortable": "",
      "prop": "Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Contacts",
      "label": "联系人",
      "width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "min-width": "100",
      "sortable": "",
      "prop": "Status"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Date",
      "label": "时间",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("设置")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "215px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Name", $$v)
      },
      expression: "editForm.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "自定义编码"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "215px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.Code),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Code", $$v)
      },
      expression: "editForm.Code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "215px"
    },
    model: {
      value: (_vm.editForm.Contacts),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Contacts", $$v)
      },
      expression: "editForm.Contacts"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态设置"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.changeStatus),
      callback: function($$v) {
        _vm.changeStatus = $$v
      },
      expression: "changeStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "正常",
      "value": "正常"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "停用",
      "value": "停用"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.setStatus(_vm.editForm.DataID)
      }
    }
  }, [_vm._v("变更状态")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "100px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "215px"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.Name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Name", $$v)
      },
      expression: "addForm.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "自定义编码"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "215px"
    },
    model: {
      value: (_vm.addForm.Code),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Code", $$v)
      },
      expression: "addForm.Code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "215px"
    },
    model: {
      value: (_vm.addForm.Contacts),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Contacts", $$v)
      },
      expression: "addForm.Contacts"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态设置"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.addForm.Status),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "Status", $$v)
      },
      expression: "addForm.Status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "正常",
      "value": "正常"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "停用",
      "value": "停用"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99d65d4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ownerConfig/ownerList.vue
// module id = 847
// module chunks = 1